import AccordionRoot from './AccordionRoot'
import AccordionContent from './AccordionContent'
import AccordionTitle from './AccordionTitle'

export const Accordion = {
    Root: AccordionRoot,
    Content: AccordionContent,
    Title: AccordionTitle,
}